import { Outlet } from "react-router-dom";

export default function PerformancesOutlet() {
  return <Outlet />;
}
